<template>
  <el-dialog
    title="请确认您的操作!"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="handleClose"
  >
    <div align="center">
      <p>确定删除资产盘点</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDeleteAssetInventoryModel">点错了</el-button>
      <el-button type="primary" @click="deleteAssetInventory">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteAssetInventory } from '@/api/goods/assetInventoryApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteAssetInventory',
  data() {
    return {
      dialogVisible: false,
      deleteAssetInventoryInfo: {}
    }
  },
  methods: {
    open(data) {
      this.deleteAssetInventoryInfo = data
      this.dialogVisible = true
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    closeDeleteAssetInventoryModel() {
      this.dialogVisible = false
    },
    async deleteAssetInventory() {
      this.deleteAssetInventoryInfo.shopId = getShopId()
      try {
        const res = await deleteAssetInventory(this.deleteAssetInventoryInfo)
        if (res.code === 0) {
          this.$emit('refresh')
          this.$message.success('删除成功')
          this.dialogVisible = false
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败处理', error)
        this.$message.error('删除失败')
      }
    }
  }
}
</script>